<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%; height: 48px;margin-bottom: 1px;background-color: #ffffff;">
      <el-menu default-active="1" class="horizontal-menu" @select="menuSelect"
               mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(0, 0, 0, 1)">
        <template v-for="sub in energyItem">
          <el-menu-item class="horizontal-menu-item" :key="sub.id" :index="sub.id">
            <span style="font-size: 14px;">{{sub.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-row>
    <el-row style="width: 100%;height: calc(100% - 49px);display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick" node-key='id' :filter-node-method="filterNode"
                 :default-expanded-keys="expandKeys" highlight-current ref="tree" class="aside-tree">
          <span slot-scope="{ node, data }">
            <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
            <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
            <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;height: 48px;line-height: 48px;color: rgb(127, 127, 127);display: flex;">
          <el-row style="text-align: left;width: 40%;height: 48px;line-height: 48px;">
            <span style="margin-left: 24px;">时间：</span>
            <el-radio-group v-model="radio" @change="selBack" style="margin-left: 8px;" size="small">
              <el-radio-button label="年"></el-radio-button>
              <el-radio-button label="月"></el-radio-button>
            </el-radio-group>
            <el-date-picker v-model="startDate" style="width: 140px;margin-left: 16px" :type="type"
                            placeholder="选择日期" :value-format="format" :clearable="false"/>
            <el-button class="search-btn-blue" style="margin-left: 16px;" @click="getChartData" type="primary" size="mini">查询</el-button>
          </el-row>
          <el-row style="text-align: right;width: 60%;height: 48px;line-height: 48px;">
            <el-radio-group class="tt-input" style="margin-right: 10px;" size="small" v-model="radioBtn" @change="selBack2">
              <el-radio-button v-for="(radioItem, i) in radioGroups" :key="i" :label="i">{{radioItem.typeName}}</el-radio-button>
            </el-radio-group>
          </el-row>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row style="overflow-y: auto;height: calc(100% - 49px);width: 100%;">
          <el-row style="height: calc(50% - 1px);width: 100%;">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <span style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">数据曲线</span>
            </el-row>
            <common-charts :init-options="initOptions" class="electric-parameter-charts"
                           :index="200" :key="timestamp" :options="chartData" autoresize :style="{'height': ((bgSize.height - 244) / 2) + 'px', 'width': (bgSize.width - 452) + 'px'}" />
          </el-row>
          <el-row style="height: 1px;width: 100%;background-color: #FFF" />
          <el-row style="height: calc(50% - 1px);width: 100%;" class="table">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <el-menu :default-active="0" class="horizontal-menu" @select="panelSelect"
                       mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(242, 242, 242, 1)">
                <el-menu-item class="horizontal-menu-item" :key="0" :index="0">
                  <span style="font-size: 14px;">分析</span>
                </el-menu-item>
                <el-menu-item class="horizontal-menu-item" :key="1" :index="1">
                  <span style="font-size: 14px;">说明</span>
                </el-menu-item>
              </el-menu>
            </el-row>
            <el-table v-show="radioBtn === 0 && selPanel === 0" border fit :data="tableData" height="calc(100% - 48px)" width="100%" ref="tableData">
              <el-table-column v-for="(item,i) in tableProps" :key="i+tableData"
                               :prop="item.prop" :label="item.hasOwnProperty('unit') ? item.label + '(' + item.unit + ')' : item.label" :width="item.width">
              </el-table-column>
            </el-table>
            <el-row v-show="radioBtn === 0 && selPanel === 1" style="width: 99%; height: calc(100% - 48px);text-align: left;font-size: 14px;margin-left: 1%;">
              <el-row v-if="radioBtn === 0 && analyseFlag === 1" style="height: 32px;line-height: 32px;margin-top: 8px;">选择按{{mode}}计费更为经济。</el-row>
              <el-row v-if="radioBtn === 0 && analyseFlag === 1" style="height: 32px;line-height: 32px;">建议当企业需量基本稳定在变压器容量的{{powerProp}}以下时，选择按需量计费，大于{{powerProp}}时，选择按容量计费。</el-row>
              <el-row v-if="radioBtn === 0 && analyseFlag === 0" style="height: 32px;line-height: 32px;margin-top: 8px;">数据或参数不足，无法进行分析。</el-row>
            </el-row>
            <el-table v-show="radioBtn === 1 && selPanel === 0" border fit :data="tableData" height="calc(100% - 48px)" width="100%" ref="tableData">
              <el-table-column v-for="(item,i) in tableProps2" :key="i+tableData"
                               :prop="item.prop" :label="item.hasOwnProperty('unit') ? item.label + '(' + item.unit + ')' : item.label" :width="item.width">
              </el-table-column>
            </el-table>
            <el-row v-show="radioBtn === 1 && selPanel === 1" style="width: 99%; height: calc(100% - 48px);text-align: left;font-size: 14px;margin-left: 1%;">
              <el-row style="height: 32px;line-height: 32px;margin-top: 8px;">变压器的合理运行影响供电的安全可靠性、电网运行的经济性。负载率过低，浪费资金。负载率过高，安全可靠性降低。请尽量保证变压器运行时负载率在65%-75%之间。</el-row>
            </el-row>
          </el-row>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import DateUtils from "../../../utils/DateUtils";
import buildCommonConfig from "../../../config/chart/config_common_line";
import CommonCharts from "../../common/chart/CommonCharts";
export default {
  name: "TransferAnalyse",
  components: {CommonCharts},
  data() {
    return {
      radio: '月',
      initOptions: {
        renderer: 'canvas'
      },
      timestamp: 0,
      chartData: {},
      circleData: {},
      lineData: {},
      selNode: '',
      treeData: [],
      expandKeys: [],
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      type: 'month',
      dateType: 2,
      startDate: DateUtils.getYesterday().Format('yyyy-MM'),
      format: 'yyyy-MM',
      energyItem: [{'id': '1', 'name': '电'}],
      bgSize: {'width': window.innerWidth, 'height': window.innerHeight},
      filterName: '',
      unit: 'kW',
      media: '1',
      tableProps: [
        {prop: "priceMode", label: "计费方式"},
        {prop: "calDemand", label: "计费功率", unit: 'kW'},
        {prop: "sinPrice", label: "计费单价", unit: '元'},
        {prop: "price", label: "预计基本电费", unit: '元'}
      ],
      tableProps2: [
        {prop: "maxData", label: "最大值", unit: '%'},
        {prop: "maxTime", label: "最大值时间"},
        {prop: "minData", label: "最小值", unit: '%'},
        {prop: "minTime", label: "最小值时间"},
        {prop: "avgData", label: "平均值", unit: '%'}
      ],
      tableData: [],
      selPanel: 0,
      powerProp: '',
      analyseFlag: 0,
      mode: '',
      radioGroups: [{typeId: 0, typeName: '最大需量', unit: 'kWh'}, {typeId: 1, typeName: '平均负载率', unit: '%'}],
      radioBtn: 0
    }
  },
  created() {
    this.getTree('1')
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.bgSize.width = window.innerWidth
      this.bgSize.height = window.innerHeight
      this.timestamp = new Date().getTime()
    })
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    menuSelect(val) {
      this.tableData = []
      this.chartData = []
      this.timestamp = new Date().getTime();
      this.media = val
      this.getTree()
    },
    panelSelect(val) {
      this.selPanel = val
    },
    getTree() {
      this.$api.systemManage.getTransferTree().then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
          })
        }
      })
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }
      return leafNode;
    },
    handleNodeClick(cNode, node) {
      this.selNode = cNode;
      if(node.data.type === '3') {
        this.getChartData()
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data['name'].indexOf(value) !== -1;
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    selBack(val) {
      if(val === '年') {
        this.dateType = 3
        this.type = 'year'
        this.startDate = new Date().Format('yyyy')
        this.format = 'yyyy'
      }
      if(val === '月') {
        this.dateType = 2
        this.type = 'month'
        this.startDate = new Date().Format('yyyy-MM')
        this.format = 'yyyy-MM'
      }
      this.getChartData()
    },
    selBack2(val) {
      this.unit = this.radioGroups[val].unit
      this.getChartData()
    },
    getChartData() {
      if (this.selNode.type !== '3') {
        return
      }
      let params = {'id': this.selNode.id, 'dataDate': this.startDate, 'dateType': this.dateType, 'dataType': this.radioGroups[this.radioBtn].typeId}
      this.$api.energyAnalyse.getTransferDemand(params).then(res => {
        let xAxis = res.data.curve.dateTime
        let data = []
        let legend = res.data.curve.itemList
        data.push({
          name: res.data.curve.dataName,
          type: 'line',
          data: res.data.curve.dataData.split(","),
          markPoint: {
            data: [
              {type: 'max', name: '最大值', itemStyle: {color: '#FF0000'}},
              {type: 'min', name: '最小值', itemStyle: {color: '#00FF00'}}
            ]
          }
        })
        this.tableData = res.data.table
        if (this.radioBtn === 0) {
          this.analyseFlag = res.data.flag
          this.powerProp = res.data.powerProp
          this.mode = res.data.mode
        }
        this.chartData = buildCommonConfig(legend, xAxis, data, 'dataMin', this.unit);
        this.timestamp = new Date().getTime();
      })
    }
  }
}
</script>

<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  .electric-parameter-charts{
    width: 100%;
    margin-top: 0;
  }
  .new-electric-parameter-charts{
    width: 100%;
    padding: 0;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyAnalyse/TransferAnalyse.vue